(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2228);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(414);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5859);
/* harmony import */ var _components_Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3664);
/* harmony import */ var _components_Container_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7158);
/* harmony import */ var _components_PostItem_PostItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4884);
/* harmony import */ var _graphql_queries__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9699);
/* harmony import */ var _PostList_module_sass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2713);
/* harmony import */ var _PostList_module_sass__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_PostList_module_sass__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7290);















var query = (0,_graphql_queries__WEBPACK_IMPORTED_MODULE_6__/* .getPostsQuery */ .gK)().query;
var PostList = function(param) {
    var list = param.list, pageInfo = param.pageInfo;
    var ref;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useLazyQuery */ .t)(query), 2), fetchMore = ref1[0], loading = ref1[1].loading;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(_utils__WEBPACK_IMPORTED_MODULE_5__/* .postsReducer */ .jO, (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .INITIAL_STATE */ .Y6)({
        pageInfo: pageInfo,
        postList: list
    })), posts = ref2[0], dispatch = ref2[1];
    var lastItemRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var loadMore = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(posts === null || posts === void 0 ? void 0 : posts.hasMore)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetchMore({
                            variables: {
                                after: posts === null || posts === void 0 ? void 0 : posts.cursor,
                                count: 12
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    dispatch({
                        payload: data === null || data === void 0 ? void 0 : data.posts,
                        type: _utils__WEBPACK_IMPORTED_MODULE_5__/* .ACTION.UPDATE_LIST */ .om.UPDATE_LIST
                    });
                    setTimeout(_utils__WEBPACK_IMPORTED_MODULE_5__/* .scrollToShowMore */ .Db, 250);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchMore,
        posts === null || posts === void 0 ? void 0 : posts.cursor,
        posts === null || posts === void 0 ? void 0 : posts.hasMore
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var itemRef = lastItemRef.current;
        if (!("IntersectionObserver" in window) || !("IntersectionObserverEntry" in window) || !("intersectionRatio" in window.IntersectionObserverEntry.prototype)) {
            return;
        }
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            var isScrollingDown = entry.intersectionRect.top <= entry.boundingClientRect.top;
            if (entry.isIntersecting && isScrollingDown) {
                loadMore();
            }
        });
        if (itemRef) {
            observer.observe(itemRef);
        }
        return function() {
            return observer.unobserve(itemRef);
        };
    }, [
        loadMore
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_PostList_module_sass__WEBPACK_IMPORTED_MODULE_11___default().postList),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Container_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: [
                posts === null || posts === void 0 ? void 0 : (ref = posts.postList) === null || ref === void 0 ? void 0 : ref.map(function(post, index, arr) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, index === (arr === null || arr === void 0 ? void 0 : arr.length) - 1 ? {
                        ref: lastItemRef,
                        "data-last": "true"
                    } : {}), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PostItem_PostItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, post), {
                            index: index
                        }))
                    }), post.id);
                }),
                (posts === null || posts === void 0 ? void 0 : posts.hasMore) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_PostList_module_sass__WEBPACK_IMPORTED_MODULE_11___default().loadMore),
                    children: loading ? // eslint-disable-next-line @next/next/no-img-element
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        alt: "Loading...",
                        height: 44,
                        src: "/icons/loading.svg",
                        width: 44
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: loadMore,
                        children: "I want more"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostList);
PostList.propTypes = {
    list: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().array),
    pageInfo: prop_types__WEBPACK_IMPORTED_MODULE_14___default().shape({
        hasNextPage: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().bool),
        endCursor: (prop_types__WEBPACK_IMPORTED_MODULE_14___default().string)
    })
};


/***/ }),

/***/ 2228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/Container/Container.js
var Container = __webpack_require__(7158);
// EXTERNAL MODULE: ./components/Header/Header.js
var Header = __webpack_require__(5137);
// EXTERNAL MODULE: ./components/PostList/PostList.js
var PostList = __webpack_require__(3495);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Teaser/Teaser.module.sass
var Teaser_module = __webpack_require__(4993);
var Teaser_module_default = /*#__PURE__*/__webpack_require__.n(Teaser_module);
;// CONCATENATED MODULE: ./components/Teaser/Teaser.js






function Teaser(param) {
    var categoriesExtra = param.categoriesExtra, name = param.name, posts = param.posts;
    var ref, ref1;
    var buyLink = categoriesExtra === null || categoriesExtra === void 0 ? void 0 : categoriesExtra.buylink;
    var buyLinkAlternative = categoriesExtra === null || categoriesExtra === void 0 ? void 0 : categoriesExtra.buylinkalternative;
    var featuredImage = categoriesExtra === null || categoriesExtra === void 0 ? void 0 : categoriesExtra.featureimage;
    var lastIssueName = (posts === null || posts === void 0 ? void 0 : (ref = posts.nodes) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.title) || name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (Teaser_module_default()).feature,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Teaser_module_default()).imageWrapper,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: lastIssueName,
                    height: 560,
                    layout: "responsive",
                    priority: true,
                    src: featuredImage.sourceUrl,
                    unoptimized: true,
                    width: 400
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Teaser_module_default()).details,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            name,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                children: "is out now!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Teaser_module_default()).buttons,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: posts.nodes[0].slug,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: (Teaser_module_default()).button,
                                    href: posts.nodes[0].slug,
                                    children: "Check it out!"
                                })
                            }),
                            buyLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (Teaser_module_default()).button,
                                href: buyLink,
                                target: "_blank",
                                rel: "noreferrer",
                                children: "Buy now!"
                            }),
                            buyLinkAlternative && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (Teaser_module_default()).button,
                                href: buyLinkAlternative,
                                target: "_blank",
                                rel: "noreferrer",
                                children: [
                                    "Buy this issue! ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                        children: "(Alternative cover)"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
Teaser.propTypes = {
    categoriesExtra: prop_types_default().shape({
        buylink: (prop_types_default()).string,
        buylinkalternative: (prop_types_default()).string,
        featureimage: prop_types_default().shape({
            sourceUrl: (prop_types_default()).string
        })
    }),
    name: (prop_types_default()).string,
    posts: prop_types_default().shape({
        nodes: prop_types_default().arrayOf(prop_types_default().shape({
            slug: (prop_types_default()).string,
            title: (prop_types_default()).string
        }))
    })
};

// EXTERNAL MODULE: ./styles/Home.module.sass
var Home_module = __webpack_require__(3200);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./pages/index.js










var __N_SSG = true;
function Home(param) {
    var lastIssue = param.lastIssue, pageInfo = param.pageInfo, posts = param.posts;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "cake magazine - the indie, confused and sweet magazine | cake-mag.com"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Teaser, (0,_object_spread/* default */.Z)({}, lastIssue)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PostList/* default */.Z, {
                        list: posts,
                        pageInfo: pageInfo
                    })
                ]
            })
        ]
    });
}
Home.propTypes = {
    featuredImageUrl: (prop_types_default()).string,
    lastIssue: prop_types_default().shape({
        categoriesExtra: prop_types_default().shape({
            buylink: (prop_types_default()).string,
            buylinkalternative: (prop_types_default()).string,
            featureimage: prop_types_default().shape({
                sourceUrl: (prop_types_default()).string
            })
        }),
        name: (prop_types_default()).string,
        posts: prop_types_default().shape({
            nodes: prop_types_default().arrayOf(prop_types_default().shape({
                slug: (prop_types_default()).string,
                title: (prop_types_default()).string
            }))
        })
    }),
    pageInfo: prop_types_default().shape({
        hasNextPage: (prop_types_default()).bool,
        endCursor: (prop_types_default()).string
    }),
    posts: prop_types_default().arrayOf(prop_types_default().shape({
        featuredImage: (prop_types_default()).object,
        id: (prop_types_default()).string.isRequired,
        slug: (prop_types_default()).string.isRequired,
        title: (prop_types_default()).string.isRequired
    }))
};


/***/ }),

/***/ 2713:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postList":"PostList_postList__q_ZOp","loadMore":"PostList_loadMore__EhrGW"};

/***/ }),

/***/ 4993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Teaser_button__jEhy0","feature":"Teaser_feature__bWHSR","imageWrapper":"Teaser_imageWrapper__RcYXY","details":"Teaser_details__KJUDM","buttons":"Teaser_buttons__Kw8Y8"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,675,913,193,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);